const PolicyPrivacyText = `

 본 사이트는 고객님의 개인정보를 중요시하며, "정보통신망 이용촉진 및 정보보호"에 관한 법률을 준수하고 있습니다.
본 사이트는 개인정보취급방침을 통하여 이용자가 제공하는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.

　

본 사이트는 개인정보취급방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.

　

ο 본 방침은 2023년 8월 20일 부터 시행됩니다.

　

■ 수집하는 개인정보의 항목

본 사이트는 서비스 제공을 위해 아래와 같은 개인정보를 수집하고 있습니다.

ο 회원가입 시 수집되는 항목 : 이메일, 닉네임, MBTI

ο 별도로 수집되는 항목 : 프로필 사진, 한줄 소개

ο 서비스 이용 과정에서 이용 기록 및 로그 기록이 자동으로 수집 될 수 있습니다.

　

■ 개인정보의 수집 및 이용목적

본 사이트는 수집한 개인정보를 다음의 목적을 위해 활용합니다.

ο 서비스 제공에 관한 계약 이행 및 서비스 제공
ο 회원 관리
회원제 서비스 이용에 따른 본인확인, 개인 식별, 불량회원의 부정 이용 방지와 비인가 사용 방지 가입 의사 확인, 불만처리 등 민원처리, 고지사항 전달

　

■ 개인정보의 보유 및 기간

본 사이트는 개인정보 수집 및 이용목적이 달성된 후에는 예외 없이 해당 정보를 지체 없이 파기합니다.

　

■ 개인정보의 파기 절차 및 방법

본 사이트는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이 파기합니다. 파기절차 및 방법은 다음과 같습니다.

ο 파기절차
회원님이 회원가입 등을 위해 입력하신 정보는 목적이 달성된 후 별도의 DB로 옮겨져 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라저장된 후 탈퇴 시점으로부터 14일 후에 파기되어집니다. 별도 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유되어지는 이외의 다른 목적으로 이용되지 않습니다. 

ο 파기방법

전자적 파일형태로 저장된 개인정보는 기록을 재생이 불가능한 방법을 사용하여 삭제합니다.

　

■ 개인정보 제공

본 사이트는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.

- 이용자들이 사전에 동의한 경우
- 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우

　

■ 수집한 개인정보의 위탁

신뢰도가 검증된 다음 회사 및 서비스에 데이터를 저장하고 있습니다.

ο Amazon Web Service, Inc. : 서비스 시스템 제공, 데이터 관리 및 보관

　

■ 이용자 및 법정대리인의 권리와 그 행사방법

이용자 및 법정 대리인은 언제든지 등록되어 있는 자신 혹은 당해 만 14세 미만 아동의 개인정보를 조회하거나 수정할 수 있으며 가입해지를 요청할 수도 있습니다.
이용자 혹은 만 14세 미만 아동의 개인정보 조회, 수정을 위해서는 ‘개인정보변경’(또는 ‘회원정보수정’ 등)을 가입해지(동의철회)를 위해서는 “회원탈퇴”를 클릭하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다. 혹은 개인정보관리책임자에게 전화 또는 이메일로 연락하시면 지체없이 조치하겠습니다. 귀하가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 
본 사이트는 이용자 혹은 법정 대리인의 요청에 의해 해지 또는 삭제된 개인정보는 본 사이트가 수집하는 개인정보의 보유 및 이용기간에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.

　

■ 개인정보에 관한 민원서비스

본 사이트는 고객의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 관련 부서 및 개인정보관리책임자를 지정하고 있습니다.

　

개인정보관리책임자 성명 : 유지수
전화번호 : 010-7713-1554
이메일 : jisuyu591@gmail.com

귀하께서는 본 사이트의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보관리책임자 혹은 담당부서로 신고하실 수 있습니다. 본 사이트는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.

　

기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.

1.개인분쟁조정위원회 ([www.1336.or.kr/1336](http://www.1336.or.kr/1336))

2.정보보호마크인증위원회 ([www.eprivacy.or.kr/02-580-0533~4](http://www.eprivacy.or.kr/02-580-0533~4))

3.대검찰청 인터넷범죄수사센터 (http://icic.sppo.go.kr/02-3480-3600)

4.경찰청 사이버테러대응센터 ([www.ctrc.go.kr/02-392-0330](http://www.ctrc.go.kr/02-392-0330))
 `;

export default PolicyPrivacyText;
